import { useMaskito } from "@maskito/react";
import type { ComponentProps } from "react";
import TextField from "./text-field";
import type { RefCallBack } from "react-hook-form";

interface Props extends ComponentProps<typeof TextField> {
  formRef?: RefCallBack;
}

const DUIField = ({ formRef, ...props }: Props) => {
  const duiMaks = useMaskito({
    options: {
      mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/],
    },
  });

  return (
    <TextField
      {...props}
      value={props.value}
      onChange={props.onChange}
      ref={(el) => {
        formRef?.(el);
        duiMaks(el);
      }}
    />
  );
};

export default DUIField;
